import React from 'react';
import {
  Button,
  Modal,
  ModalSection,
  ModalHeader,
  ModalFooter,
  Paragraph,
} from '@axiom/ui';

export type ProfileImageEditPhotoConsentModalProps = {
  name?: string;
  onConsent: () => void;
  onDecline: () => void;
};

export const ProfileImageEditPhotoConsentModal = ({
  name = 'PROFILE_IMAGE_EDIT_PHOTO_CONSENT_MODAL',
  onConsent,
  onDecline,
}: ProfileImageEditPhotoConsentModalProps) => (
  <Modal name={name}>
    <ModalHeader onClose={onDecline}>Photo Consent</ModalHeader>
    <ModalSection>
      <Paragraph>
        You have the option to upload your photograph to the Axiom Platform. If
        you choose to upload your photograph, you are giving us your consent for
        your photograph to be featured alongside your profile when it is
        submitted to clients, when clients or prospective clients are searching
        for lawyers on our website, and/or when you are on clients' benches. You
        may update your photograph or delete it entirely from your profile (in
        the event that you change your mind about sharing it). There is no
        obligation to upload a photograph at all and if you choose not to do so,
        this will not have any consequences on how Axiom supports you in finding
        suitable client engagements.
      </Paragraph>
    </ModalSection>
    <ModalFooter>
      <Button variation="outline" name="CANCEL" onClick={onDecline}>
        I do not consent
      </Button>

      <Button name="SUBMIT" onClick={onConsent}>
        I consent
      </Button>
    </ModalFooter>
  </Modal>
);
